import { render, staticRenderFns } from "./SharingComponent.vue?vue&type=template&id=041df740&"
import script from "./SharingComponent.vue?vue&type=script&lang=js&"
export * from "./SharingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports